import { render, staticRenderFns } from "./FeaturedListingsManager.vue?vue&type=template&id=8f9d5bea&scoped=true&lang=pug&"
import script from "./FeaturedListingsManager.vue?vue&type=script&lang=js&"
export * from "./FeaturedListingsManager.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedListingsManager.vue?vue&type=style&index=0&id=8f9d5bea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9d5bea",
  null
  
)

export default component.exports